import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Breadcrumbs from "../layouts/Breadcrumbs";
import Footer from "../layouts/Footer";
import Content from "../sections/error-page/Content";

const pagelocation = "Error 404";

class Errorpage extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>{pagelocation}</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />
        <Breadcrumbs
          currentPath={this.props.location.pathname}
          breadcrumb={{ pagename: pagelocation }}
        />
        <Content />
        <Footer />
      </Fragment>
    );
  }
}

export default Errorpage;
